import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowLeft } from "@phosphor-icons/react";
import useSeo from "../lib/useSeo";
import { useT, usePick } from "../lib/i18n";

export default function BlogDetail() {
  const t = useT();
  const pick = usePick();
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState(false);
  useSeo({
    title: post ? pick(post, "title") : undefined,
    description: post ? pick(post, "excerpt") : undefined,
    image: post?.cover_image,
  });

  useEffect(() => {
    api.get(`/blog/${slug}`).then(r => setPost(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err) return (
    <div className="py-32 text-center" data-testid="blog-detail-404">
      <div className="overline">404</div>
      <h1 className="font-serif-display text-5xl mt-4">{t("common.notFound")}</h1>
      <Link to="/blog" className="mt-6 inline-flex items-center gap-2 text-terracotta"><ArrowLeft size={16}/> {t("blog.back")}</Link>
    </div>
  );
  if (!post) return <div className="py-32 text-center text-muted-foreground">{t("common.loading")}</div>;

  return (
    <article className="pb-32" data-testid="blog-detail-page">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 py-16 lg:py-24">
        <Link to="/blog" className="inline-flex items-center gap-2 text-muted-foreground hover:text-terracotta text-sm mb-8"><ArrowLeft size={16}/> {t("blog.back")}</Link>
        <div className="overline">{post.category}</div>
        <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1]">{pick(post, "title")}</h1>
        <p className="mt-6 text-lg text-muted-foreground italic">{pick(post, "excerpt")}</p>
      </div>
      {post.cover_image && (
        <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="aspect-[21/9] rounded-2xl overflow-hidden bg-ivory">
            <img src={post.cover_image} alt={`${pick(post, "title")} — Yuva Ayurvedic Clinic Prayagraj`} className="w-full h-full object-cover" loading="lazy" decoding="async"/>
          </div>
        </div>
      )}
      <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 py-16 prose prose-lg prose-stone font-serif-display" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
        <div className="text-xl leading-relaxed text-foreground/90" dangerouslySetInnerHTML={{ __html: pick(post, "content") }}/>
      </div>
      <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 text-sm text-muted-foreground">
        — {post.author}
      </div>
    </article>
  );
}
